<template>
  <button
    :id="target"
    class="btn-tooltip"
    :class="[variant]"
    tabindex="-1"
    @click="clickHandler"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BtnTooltip",
  props: {
    target: { type: String, default: "" },
    variant: { type: String, default: "" },
  },
  emits: ["click"],
  methods: {
    clickHandler: function (e) {
      e.preventDefault();
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-tooltip {
  &.-question {
    position: absolute;
    right: 10px;
    bottom: 10px;
    display: inline-block;
    border-radius: 12px;
    background-color: $gray;
    background-image: url("@/assets/images/icons/question.svg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 8px auto;
    width: 24px;
    height: 24px;
  }
}

@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .btn-tooltip.-question {
    float: right;
    margin-bottom: -12px;
    position: static;
  }
}
</style>
